import { render } from "./StoreComplianceBadges.vue?vue&type=template&id=d62c27b8&scoped=true"
import script from "./StoreComplianceBadges.vue?vue&type=script&lang=js"
export * from "./StoreComplianceBadges.vue?vue&type=script&lang=js"

import "./StoreComplianceBadges.vue?vue&type=style&index=0&id=d62c27b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d62c27b8"]])

export default __exports__